import React from "react";
import PropTypes from "prop-types";
import {
    Row,
    Col,
    Button,
    Modal,
    List as AntList,
    Card,
    Checkbox,
    Icon,
    Tag,
    message,
    // eslint-disable-next-line no-unused-vars
    Select, Input, Typography,
    DatePicker,
    InputNumber,
    Radio,
    Descriptions,
    Switch,
} from "antd";
import moment from "moment";
const { Title } = Typography;
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AccountFacilityForm from "forms/account-facility-form";
import { FacilityAccountRecord } from "records";
import _max from "lodash/max";
import CaseService from "services/case-service";
import {
    createFacilityAccount,
    fetchFacilityAccount,
    fetchFacilityAccountSupplyChains,
    updateFacilityAccountSupplyChains,
    updateProcessingFee,
    updateCaseDetail,
    fetchCaseDetail,
    fetchBounceCharges,
    fetchPrePaymentCharges,
    fetchFee,
    fetchCaseNotes
} from "store/actions";
import FacilityAccountService from "services/facility-account-service";
import { formatCurrency } from "utilities";
import { List, Map, OrderedMap } from "immutable";
import UTRForm from "forms/UTRForm";
import { GenericToolTip } from "../../components/genericTooltip";
import CompanyFeeForm from "../../modules/companies/forms/company-fee-form";
import CompanyBounceChargeForm from "../../modules/companies/forms/company-bounce-charge-form";
import CompanyPrePaymentChargeForm from "../../modules/companies/forms/company-pre-payment-charge-form";
import CompanyLosServices from "../../modules/companies/services/company-los-services";
import { BUSINESS_PRODUCT_TYPE_UPDATED } from "../../constants/enums";
import { Table } from "components/table"; 
import ConfirmButton from "../../components/confirm-button";

const ListItem = AntList.Item;
const { Title: Paragraph } = Typography;

const PRICING_APPROVAL_UI = {
    approve: { color: "#52c41a", icon: "check-circle", label: "Approve" },
    refer_back_l1: { color: "#fa8c16", icon: "rollback", label: "Refer back L1" },
    refer_back_l2: { color: "#d4380d", icon: "rollback", label: "Refer back L2" },
    recommended_to_l1: { color: "#1890ff", icon: "right-circle", label: "Recommended to L1" },
    recommended_to_l2: { color: "#096dd9", icon: "right-circle", label: "Recommended to L2" },
};

const radioStyle = {
    display: "block",
    width: "400px",
    height: "30px",
    lineHeight: "30px",
};

const scheduleCharges = {
    processing_fee: {
        title: "Processing fee",
        value: null,
        type: "label"
    },
    documentation_charges: {
        title: "Documentation charge",
        value: null,
        type: "label"
    },
    cheque_bounce_charges:{
        title: "Cheque Bounce Charges",
        value: null,
        type: "label"
    },
    foreclosure_charges:{
        title: "Foreclosure Charges",
        value: null,
        type: "table"
    }
    // cheque_bounce_charges: {
    //     title: "Cheque bounce charge",
    //     value: null
    // },
    // late_payment_fee: {
    //     title: "Late payment fee",
    //     value: null
    // },
    // foreclosure_charges: {
    //     title: "Foreclosure charge",
    //     value: null
    // },
    // yearOfClosure: {
    //     title: "Year of Closure",
    //     value: "% of Total outstanding"
    // },
    // yearOfClosure1: {
    //     title: "1",
    //     value: null
    // },
    // yearOfClosure2: {
    //     title: "2",
    //     value: null
    // },
    // yearOfClosure3orMore: {
    //     title: "3 or More",
    //     value: null
    // },
    // other_charges: {
    //     title: "Other Charges",
    //     value: null
    // },
    // otherCharges1: {
    //     title: "Charge 1",
    //     value: null
    // },
    // otherCharges2: {
    //     title: "Charge 2",
    //     value: null
    // },
    // otherCharges3: {
    //     title: "Charge 3",
    //     value: null
    // },
};

const emiInstanceColumns = {
    instalment_nbr: {
        title: "EMI",
        value: null,
        type: '',
    },
    emi_amount: {
        title: "EMI Amount",
        value: null,
        type: 'amount',
    },
    principal_amount: {
        title: "Principal Amount",
        value: null,
        type: 'amount',
    },
    interest_amount: {
        title: "Interest Amount",
        value: null,
        type: 'amount',
    },
    principal_receivable: {
        title: "Outstanding Loan",
        value: null,
        type: 'amount',
    },
    interest_paid_till_date: {
        title: "Cumulative Interest Amount",
        value: null,
        type: 'amount',
    },
    tentative_due_date: {
        title: "Tentative Due Date",
        value: null,
        type: '',
    },
    upfront_interest_amount: {
        title: "Upfront Interest Amount",
        value: null,
        type: '',
    }
};

const InstalmentFrequencyType = {
    1: 'Day Set',
    2 : 'Monthly'
}

const InstalmentDateType={
    1: 'Fixed',
    2: 'Basis Disbursal Date'
}

const InterestType = {
    1: 'Flat',
    2: 'Reducing'
}

const FEE_PRODUCT_TYPE = {
    SCF: 1,
    TERM_LOAN: 2,
    VENDOR_FINANCE: 3,
    FACTORING: 4
};

const START_DATE = "from_date";

const SKIP_POD_STAGE_IDS = [11, 57, 35, 24, 13, 17];
const SKIP_POD_READONLY_STAGE_IDS = [57, 35, 24, 13, 17];

class AccountFacilityTab extends React.Component {

    state = {
        processing_fee_amount: 0,
        isProcessing_fee_fetched: false,
        pfAmountModal: {
            visible: false,
            loading: false,
            submitting: false,
            feePrograms: [],
            form: {
                feeMasterId: null,
                remarks: ""
            }
        },
        skipPod: { value: false, loading: false, modal: null },
        // Per-modal submit-in-progress flags for the Fee/Bounce/Pre-payment
        // "Add/Update Program" modals — drives each modal's own Button loading
        // spinner + disables it, instead of the modal showing no feedback and
        // staying clickable while changeFee's save + refetch are in flight.
        changeFeeLoading: {
            fee: false,
            bounce_charge: false,
            pre_payment_charge: false
        },
        skipPodRemarks: "",
        latestPricingLoading: false,
        latestPricing: null,
        toggleSanctionModal: false,
        sanctionConditions: [],
        selectedCondition: null,
        showUtrModal: false,
        showSanctionTerminationModal: false,
        sanctionTerminationRemarks: null,
        update_processing_fee: 0,
        update_processsing_fee_fetched: false,
        emiInstancefields: {},
        generateScehduleData: [],
        emiInstanceToFillFields: { principal: null, tenure: null },
        scheduleOfChargesData: {},
        isBnplListDataPresent: false,
        callBnplSet: true,
        showErr: false,
        showTenorErr: false,
        errMsg: null,
        from_date: null,
        moratoriumDays: null,
        emiType : "1",
        add_fees_to_first_tranche : false,
        first_instalment_deducted_from_disbursal : false,
        save_data: {
            tenure : "",
            moratorium_days: "",
            emiType: "1",
            is_first_instalment_deducted_from_disbursal: false,
            from_date: "",
            fee : "",
            charge : "",
            foreclosure_master: ""
        },

    };
    sanctionConditions = [];

    
    componentDidMount() {
        this.props.fetchFacilityAccountSupplyChains(this.props.caseId);
        this.fetchLatestPricing();
        if (SKIP_POD_STAGE_IDS.includes(this.props.stageId)) {
            this.fetchSkipPodStage();
        }
        //  this.setBnplLoanData();
        if([7,8].includes(this.props.stageId)){
            FacilityAccountService.getSavedSchedule(this.props.caseId)
            .then(({data}) => {
                this.setState(prevState => ({
                    save_data: {  
                      ...prevState.saveData, 
                      moratorium_days :data['moratorium_days'],
                      tenure : data.tenure,
                      emiType: data.emi_type,
                      is_first_instalment_deducted_from_disbursal : data.is_first_instalment_deducted_from_disbursal,
                      from_date: moment(data.tentative_disbursal_date),
                    //   fee : data.fee_seller_mapping_id,
                    //   charge : data.bounce_charge,
                    //   foreclosure_master: data.foreclosure_master
          
                    }
                  }));
            })
        }

    }

    fetchLatestPricing = () => {
        this.setState({ latestPricingLoading: true });
        CaseService.getLatestPricingApproval(this.props.caseId)
            .then(({ data }) => {
                this.setState({
                    latestPricingLoading: false,
                    latestPricing: data || null
                });
            })
            .catch((err) => {
                const apiMsg =
                    err?.non_field_errors?.[0] ||
                    err?.response?.data?.non_field_errors?.[0] ||
                    null;
                if (apiMsg) {
                    message.error(apiMsg);
                } else {
                    message.error("Case Pricing Approval not found.");
                }
                this.setState({ latestPricingLoading: false, latestPricing: null });
            });
    }

    getPricingSummary = () => {
        const pricing = this.state.latestPricing || {};
        const updatedAt = pricing?.updated_at || null;
        const roi = pricing?.roi ?? null;
        const pf = pricing?.pf ?? null;
        const pfType = pricing?.pf_type ?? null;
        const tenor = pricing?.tenor ?? null;
        const emiType = pricing?.emi_type ?? null;
        const s = pricing?.approval_status;
        const key = s != null && s !== "" ? String(s).trim().toLowerCase() : null;
        const approvalStatusUi = key
            ? (PRICING_APPROVAL_UI[key] || {
                color: "#6b7280",
                icon: "info-circle",
                label: key.replace(/_/g, " "),
            })
            : null;
        const pfText =
            pf == null
                ? "--"
                : Number(pfType) === 2
                    ? `${pf}%`
                    : Number(pfType) === 1
                        ? `₹${formatCurrency(pf)}`
                        : `${pf}`;
        return {
            updatedAt,
            roiText: roi != null ? `${roi}%` : "--",
            pfText,
            tenorText: tenor != null ? `${tenor}M` : "--",
            emiText: emiType != null ? `${emiType}` : "--",
            approvalStatusUi,
        };
    }
    setBnplLoanData() {
        FacilityAccountService.getBNPLlistingV2(this.props.caseId).then(({ data }) => {
            if (data.prefetch.length || data.message == "Success") {
                let allowed = []
                if(data.message == "Success"){
                    allowed = ["instalment_nbr", "emi_amount", "principal_amount", "interest_amount", "principal_receivable", "interest_paid_till_date", "tentative_due_date", "upfront_interest_amount"];
                }else{
                    allowed = ["instalment_nbr", "aggregate_emi_amount", "aggregate_principal_amount", "aggregate_interest_amount", "aggregate_principal_receivable", "aggregate_interest_paid_till_date", "tentative_due_date", "aggregate_upfront_interest_amount"];
                }
                const redux = array => array.map(o => allowed.reduce((acc, curr) => {
                    acc[curr] = o[curr];
                    return acc;
                }, {}));
                let filterEmiSchData = redux(data.emi_schedule);
                const dataStr = [];
                filterEmiSchData.map((item) => {
                    let orgData = {
                        "instalment_nbr": item.instalment_nbr,
                        "emi_amount": item.aggregate_emi_amount || item.emi_amount,
                        "principal_amount": item.aggregate_principal_amount || item.principal_amount || 0,
                        "interest_amount": item.aggregate_interest_amount || item.interest_amount,
                        "principal_receivable": item.aggregate_principal_receivable || item.principal_receivable,
                        "interest_paid_till_date": item.aggregate_interest_paid_till_date || item.interest_paid_till_date || 0,
                        "tentative_due_date": item.tentative_due_date,
                        "upfront_interest_amount" : item.upfront_interest_amount || item.aggregate_upfront_interest_amount
                    };
                    dataStr.push(orgData);
                });
                this.setState(prevState => ({
                    save_data: {  
                      ...prevState.save_data, 
                      moratorium_days :data.prefetch['max_moratorium_period']          
                    },
                    emiInstancefields: data.message ? data.prefetch :  data.prefetch[0], generateScehduleData: dataStr, isBnplListDataPresent: true , moratoriumDays : data.prefetch['max_moratorium_period']
                  }))
            } else {
                FacilityAccountService.getEmiInstanceValues(this.props.caseId).then(({ data }) => {
                    return (
                        this.setState(prevState => ({
                            save_data: {  
                              ...prevState.save_data, 
                              moratorium_days :data.data['max_moratorium_period']          
                            },
                            emiInstancefields: data.data, isBnplListDataPresent: false ,moratoriumDays : data.data['max_moratorium_period']
                          }))
                    );
                });
            }
        }).catch(() => {
            FacilityAccountService.getEmiInstanceValues(this.props.caseId).then(({ data }) => {
                return (
                    this.setState(prevState => ({
                        save_data: {  
                          ...prevState.save_data, 
                          moratorium_days :data.data['max_moratorium_period']          
                        },
                        emiInstancefields: data.data, isBnplListDataPresent: false , moratoriumDays : data.data['max_moratorium_period']
                      }))
                );
            });
        });
        FacilityAccountService.getScheduleOfChargesBNPL(this.props.caseId).then(({ data }) => {
            if (data) {
                return (
                    this.setState({
                        scheduleOfChargesData: {
                            processing_fee: {
                                title: "Processing fee",
                                value: String(data.data.processing_fee)
                            },
                            documentation_charges: {
                                title: "Documentation charge",
                                value: data.data.documentation_charges
                            },
                            foreclosure_charges: {
                                title : "foreclosure_charges",
                                value : data.data.foreclosure_charges && data.data.foreclosure_charges
                            },
                            cheque_bounce_charges: {
                                title: "Cheque bounce charge",
                                value: data.data.cheque_bounce_charges
                            },
                            // late_payment_fee: {
                            //     title: "Late payment fee",
                            //     value: data.data.late_payment_fee
                            // },
                            // foreclosure_charges: {
                            //     title: "Foreclosure charge",
                            //     value: null
                            // },
                            // yearOfClosure: {
                            //     title: "Year of Closure",
                            //     value: "% of Total outstanding"
                            // },
                            // yearOfClosure1: {
                            //     title: "1",
                            //     value: "4%"
                            // },
                            // yearOfClosure2: {
                            //     title: "2",
                            //     value: "3%"
                            // },
                            // yearOfClosure3orMore: {
                            //     title: "3 or More",
                            //     value: "2%"
                            // },
                            // other_charges: {
                            //     title: "Other Charges",
                            //     value: null
                            // },
                            // otherCharges1: {
                            //     title: "Charge 1",
                            //     value: data.data.other_charges[0]["Charge 1"]
                            // },
                            // otherCharges2: {
                            //     title: "Charge 2",
                            //     value: data.data.other_charges[0]["Charge 2"]
                            // },
                            // otherCharges3: {
                            //     title: "Charge 3",
                            //     value: data.data.other_charges[0]["Charge 3"]
                            // },
                        }
                    })
                );
            } else {
                return;
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.processingFeeAmountFromCaseDetails !== null && !this.state.isProcessing_fee_fetched) {
            this.setState({
                processing_fee_amount: parseFloat(this.props.processingFeeAmountFromCaseDetails),
                isProcessing_fee_fetched: true
            });
        } else if (this.props.supplyChains && this.props.supplyChains.size && !this.state.isProcessing_fee_fetched) {
            const data = this.props.supplyChains.map(_ => _.processing_fee_amount).toJS();
            this.setState({
                processing_fee_amount: _max(data),
                isProcessing_fee_fetched: true
            });
        }

        if (this.props.supplyChains && this.props.supplyChains.size && !this.state.update_processsing_fee_fetched) {
            const data = this.props.supplyChains.map(_ => _.processing_fee_amount).toJS();
            this.setState({
                update_processing_fee: this.props.processingFeeAmountFromCaseDetails == null ? _max(data) : parseFloat(this.props.processingFeeAmountFromCaseDetails),
                update_processsing_fee_fetched: true
            });
        }
        if (this.state.callBnplSet && this.props.caseDetails?.toJS()?.is_bnpl_case) {
            this.setState({ callBnplSet: false }, this.setBnplLoanData());
        }

        if (
            SKIP_POD_STAGE_IDS.includes(this.props.stageId) &&
            (prevProps.stageId !== this.props.stageId || prevProps.caseId !== this.props.caseId)
        ) {
            this.fetchSkipPodStage();
        }

    }

    fetchSkipPodStage = () => {
        this.setState(({ skipPod }) => ({ skipPod: { ...skipPod, loading: true } }));
        CaseService.getSkipPodStage(this.props.caseId)
            .then(({ data }) => this.setState(({ skipPod }) => ({
                skipPod: { ...skipPod, loading: false, value: !!data?.is_skip_pod_stage }
            })))
            .catch(() => this.setState(({ skipPod }) => ({ skipPod: { ...skipPod, loading: false } })));
    }

    onSkipPodToggle = (pending) => {
        if (
            this.props.recreditViewOnlyPermission ||
            this.state.skipPod.modal ||
            SKIP_POD_READONLY_STAGE_IDS.includes(this.props.stageId)
        ) {
            return;
        }
        this.setState({
            skipPod: { ...this.state.skipPod, modal: { pending, submitting: false } },
            skipPodRemarks: "",
        });
    }

    closeSkipPodModal = () => {
        this.setState({
            skipPod: { ...this.state.skipPod, modal: null },
            skipPodRemarks: "",
        });
    }

    submitSkipPodModal = () => {
        const { modal } = this.state.skipPod;
        const remarks = this.state.skipPodRemarks.trim();
        if (!remarks) return message.error("Please add remarks");
        this.setState(({ skipPod }) => ({
            skipPod: { ...skipPod, modal: { ...modal, submitting: true } }
        }));
        CaseService.skipPodStage(this.props.caseId, { is_skip_pod_stage: modal.pending, remarks })
            .then(() => {
                this.closeSkipPodModal();
                this.fetchSkipPodStage();
                this.props.fetchCaseNotes(this.props.caseId);
                message.success(modal.pending ? "POD stage skipped successfully" : "Skip POD stage decision reverted");
            })
            .catch((err) => {
                message.error(err?.non_field_errors?.[0] || err?.message || "Failed to update skip POD stage");
                this.setState(({ skipPod }) => ({
                    skipPod: { ...skipPod, modal: { ...modal, submitting: false } }
                }));
            });
    }

    getApplicableFeeProductType = () => {
        const businessProductType = Number(this.props.caseDetails.get("business_product_type"));
        if ([
            BUSINESS_PRODUCT_TYPE_UPDATED.get("INVOICE_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("PURCHASE_INVOICE_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("SALES_INVOICE_FINANCE"),
        ].includes(businessProductType)) {
            return FEE_PRODUCT_TYPE.SCF;
        }
        if ([
            BUSINESS_PRODUCT_TYPE_UPDATED.get("WORKING_CAPITAL_DEMAND_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("SHORT_TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("CONSUMER_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("LAP"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("PERSONAL_TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("RENOVATION_TERM_LOAN"),
        ].includes(businessProductType)) {
            return FEE_PRODUCT_TYPE.TERM_LOAN;
        }
        if (businessProductType === BUSINESS_PRODUCT_TYPE_UPDATED.get("VENDOR_FINANCE")) {
            return FEE_PRODUCT_TYPE.VENDOR_FINANCE;
        }
        // In this codebase, FACTORING maps to CEP.
        if (businessProductType === BUSINESS_PRODUCT_TYPE_UPDATED.get("FACTORYING") || businessProductType === BUSINESS_PRODUCT_TYPE_UPDATED.get("CEP")) {
            return FEE_PRODUCT_TYPE.FACTORING;
        }
        return null;
    }

    openPfAmountModal = () => {
        const sellerId = this.props.caseDetails.getIn(["supply_chains", 0, "seller", "id"]);
        if (!sellerId) {
            message.error("Seller details are missing for this case");
            return;
        }
        const fee_product_type = this.getApplicableFeeProductType();
        this.setState({
            pfAmountModal: {
                visible: true,
                loading: true,
                submitting: false,
                feePrograms: [],
                form: {
                    feeMasterId: null,
                    remarks: ""
                }
            }
        });
        CompanyLosServices.getFee(sellerId, fee_product_type)
            .then(({ data }) => {
                const rows = Array.isArray(data?.results)
                    ? data.results
                    : (Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []));
                this.setState(prev => ({
                    pfAmountModal: {
                        ...prev.pfAmountModal,
                        feePrograms: rows,
                        loading: false
                    }
                }));
            })
            .catch(() => {
                this.setState(prev => ({
                    pfAmountModal: {
                        ...prev.pfAmountModal,
                        loading: false
                    }
                }));
                message.error("Failed to fetch fee programs");
            });
    }

    closePfAmountModal = () => {
        this.setState({
            pfAmountModal: {
                visible: false,
                loading: false,
                submitting: false,
                feePrograms: [],
                form: {
                    feeMasterId: null,
                    remarks: ""
                }
            }
        });
    }

    onPfAmountModalFormChange = (key, value) => {
        this.setState(prev => ({
            pfAmountModal: {
                ...prev.pfAmountModal,
                form: {
                    ...prev.pfAmountModal.form,
                    [key]: value
                }
            }
        }));
    }

    submitPfAmountModal = () => {
        const { feeMasterId, remarks } = this.state.pfAmountModal.form;
        if (!feeMasterId) {
            message.error("Please select a fee program");
            return;
        }
        if (!remarks || !remarks.trim()) {
            message.error("Please add remarks");
            return;
        }
        this.setState(prev => ({
            pfAmountModal: {
                ...prev.pfAmountModal,
                submitting: true
            }
        }));
        CompanyLosServices.addCaseFeeConfiguration({
            case_id: this.props.caseId,
            fee_master_id: feeMasterId,
        }).then(() => {
            this.setState({
                isProcessing_fee_fetched: false
            });
            this.closePfAmountModal();
            this.props.fetchCaseDetail(this.props.caseId);
            message.success("Fee program submitted");
        }).catch((err) => {
            this.setState(prev => ({
                pfAmountModal: {
                    ...prev.pfAmountModal,
                    submitting: false
                }
            }));
            message.error(err?.non_field_errors?.[0] || err?.message || "Failed to submit fee program");
        });
    }

    submitForm = (values) => {
        let accountData = new FacilityAccountRecord(values);
        this.props.updateFacilityAccountSupplyChains(this.props.caseId, accountData.getSupplyChains());
        // this.props.updateCaseDetail(this.props.caseId, this.props.caseDetails.set("processing_fee_amount", this.state.processing_fee_amount));
    };

    moveCase = (evaluation, passed) => {
        const groupedList = evaluation.toList().sortBy(_ => !_.check).groupBy((_, index) => Math.floor(index / 6));
        const modal = Modal.confirm();
        modal.update({
            title: "Proceed Checklist",
            icon: passed ? (
                <Icon type="check-circle" theme={"filled"} />
            ) : null,
            onOk: () => (passed ?
                this.props.updateProcessingFee(this.props.caseId, this.state.update_processing_fee)
                : null
            ),
            okText: (passed ? "Proceed" : "Review Case"),
            okButtonProps: {
                type: passed ? "primary" : "default"
            },
            width: groupedList.size * 400,
            content: (
                <React.Fragment>
                    <Row>
                        {
                            groupedList.map((list, keyIndex) =>
                                <Col span={Math.floor(24 / groupedList.size)} key={keyIndex} className={"px-10"}>
                                    <AntList>
                                        {list
                                            .map((_, key) => (
                                                <AntList.Item key={key}>
                                                    <AntList.Item.Meta
                                                        title={_.label}
                                                    />
                                                    <Icon
                                                        type={
                                                            _.check
                                                                ? "check-circle"
                                                                : null
                                                        }
                                                        theme={"filled"}
                                                        style={{
                                                            fontSize: "18px",
                                                            color: "#246079"
                                                        }}
                                                    />
                                                </AntList.Item>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </Col>).toList().toArray()
                        }
                    </Row>
                </React.Fragment>
            )
        });

    }

    onChangeVal = (field, index, val) => {

        let value = val;
        if (value.target) {
            value = value.target.value;
        }


        Object.keys(this.fields).map(key => {
            const valueObj = this.fields[key];
            if (key == index) {
                let newValueObj = Object.assign({}, valueObj);
                newValueObj[field] = value;
                if (field === "{{ll_as_amt_of_sl}}") {
                    newValueObj["{{ll_as_perc_of_sl}}"] = null;
                } else if (field === "{{ll_as_perc_of_sl}}") {
                    newValueObj["{{ll_as_amt_of_sl}}"] = null;
                }
                this.fields[key] = newValueObj;
            } else {
                const newValueObj = Object.keys(valueObj).map(fieldKey => {
                    return { [fieldKey]: null };
                }).reduce((agg, cur) => ({ ...agg, ...cur }), {});
                this.fields[key] = newValueObj;
            }
        });
        this.setState({
            date: new Date(),
            selectedCondition: index
        });
    }

    getOption = (text, index) => {
        const field = this.fieldObj[index][text];
        if (field) {
            if (field.type === "SELECT") {
                return (
                    <Select
                        id={`${index}-${text}`}
                        size={"small"}
                        style={{ width: "65px" }}
                        onChange={this.onChangeVal.bind(null, text, index)}
                        value={this.fields[index][text]}
                        dropdownMatchSelectWidth={false}
                    >
                        {field.options.map(v => (
                            <Select.Option key={v} value={v}>{`${v}${field.suffix || ""}`}</Select.Option>)
                        )}
                    </Select>
                );
            } else {
                return (
                    <Input
                        id={`${index}-${text}`}
                        size={"small"}
                        addOnBefore={field.prefix}
                        style={{ width: "100px" }}
                        placeholder={field.placeholder}
                        value={this.fields[index][text]}
                        onChange={this.onChangeVal.bind(null, text, index)}
                    />
                );
            }
        }
        // return this.fieldObj[index][text];
    }

    openSanctionModal = () => {
        CaseService.getSanctionConditions(this.props.caseId).then((res) => {
            try {
                let data = res.data && res.data.data;
                this.sanctionConditions = data;
                let options = [];
                if (data) {
                    const variableRegex = /(\{{.*?\}})/g;
                    options = data.map((_, k) => {
                        let fields = _.title.match(variableRegex);
                        this.fieldObj = {
                            ...this.fieldObj,
                            [k]: {}
                        };
                        fields = fields.map(_ => _.split("{{")[1].split("}}")[0]);
                        fields.map(__ => {
                            this.fields = {
                                ...this.fields,
                                [k]: {}
                            };
                            this.fieldObj = {
                                ...this.fieldObj,
                                [k]: {
                                    ...this.fieldObj[k],
                                    [`{{${__}}}`]: {
                                        type: _.keys[__].type,
                                        options: _.keys[__].options,
                                        suffix: _.keys[__].suffix,
                                        title: _.title,
                                        placeholder: _.keys[__].placeholder,
                                        prefix: _.keys[__].prefix
                                    }
                                }
                            };
                        });
                        let text = _.title;
                        return text;

                    });
                }
                this.setState({
                    sanctionConditions: options,
                    toggleSanctionModal: true,
                });
            } catch (err) {
                console.error(err);
            }
        }).catch(() => {
            this.setState({
                toggleSanctionModal: true
            });
        });
    };

    openSanctionTerminationModal = () => {
        this.setState({
            showSanctionTerminationModal: true
        });
    }

    closeSanctionTerminationModal = () => {
        this.setState({
            showSanctionTerminationModal: false
        });
    }

    onChangeTerminationRemarks = (e) => {
        this.setState({
            sanctionTerminationRemarks: e.target.value
        });
    }

    terminateSanctionCondition = () => {
        CaseService.terminateSanctionConditions(this.props.caseId, this.state.sanctionTerminationRemarks).then(() => {
            this.setState({
                showSanctionTerminationModal: false,
                sanctionTerminationRemarks: null
            }, () => this.props.fetchCaseDetail(this.props.caseId));
        }).catch(() => {
            message.error("Failed to Terminate Condition");
        });
    }

    closeSanctionModal = isTrue => {
        this.setState(
            {
                toggleSanctionModal: false
            },
            () => {
                if (isTrue) {
                    const selectedSanctionCondition = this.sanctionConditions[this.state.selectedCondition];
                    const selectedConditionValues = this.fields && this.state.selectedCondition !== null && this.fields[this.state.selectedCondition];
                    let values = {
                        ...selectedSanctionCondition.keys,
                    };
                    let selectedValues = values;
                    const sanction_amount = this.props.caseDetails && this.props.caseDetails.sanction_limit;
                    Object.keys(values).map(_ => {
                        if (_ === "ll_as_perc_of_sl" && !selectedConditionValues[`{{${_}}}`] && selectedConditionValues["{{ll_as_amt_of_sl}}"] !== null) {
                            selectedValues[_].response = ((+selectedConditionValues["{{ll_as_amt_of_sl}}"] / +sanction_amount) * 100).toFixed(2);
                        } else {
                            selectedValues[_].response = selectedConditionValues[`{{${_}}}`] || selectedValues[_].response;
                        }
                    });
                    let selectedTitle = selectedSanctionCondition.title;
                    const variableRegex = /(\{{.*?\}})/g;
                    let titleFields = selectedTitle.match(variableRegex);
                    titleFields = titleFields.map(_ => _.split("{{")[1].split("}}")[0]);
                    titleFields.map(_ => {
                        selectedTitle = selectedTitle.replace(`{{${_}}}`, selectedValues[_].response);
                    });
                    let initial_loaded_limit = sanction_amount;
                    if (selectedValues && selectedValues["ll_as_perc_of_sl"]) {
                        initial_loaded_limit = ((+sanction_amount * +selectedValues["ll_as_perc_of_sl"].response) / 100).toFixed(2);
                    }
                    this.props.updateCaseDetail(
                        this.props.caseId,
                        this.props.caseDetails
                            .set("sanction_condition", { ...selectedValues, title: selectedTitle })
                            .set("initial_loaded_limit", initial_loaded_limit)
                    );
                }
            }
        );
    };

    onChangeCondition = (e) => {
        if (this.state.selectedCondition === e[e.length - 1]) {
            this.setState({
                selectedCondition: null
            });
        } else {
            this.setState({
                selectedCondition: e[e.length - 1]
            });
        }
    }

    isSanctionDisabled = () => {
        if (this.state.selectedCondition !== null) {
            let title = this.sanctionConditions[this.state.selectedCondition] &&
                this.sanctionConditions[this.state.selectedCondition].title;
            if (!title) {
                return false;
            }
            const variableRegex = /(\{{.*?\}})/g;
            const check = title.match(variableRegex);
            if (check) {
                const nullCheck = check.filter(_ => !this.fields[this.state.selectedCondition][`${_}`]);
                if (nullCheck && nullCheck.length && nullCheck.length !== 1) {
                    return true;
                }
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    moveCaseCheckList = () => {
        const { associates, caseDetails, companyDetails } = this.props;
        const all_applicants_with_phone_no =
            associates &&
            associates.find(_ => !_.phone || !_.first_name || !_.email);
        const evaluator = new OrderedMap({
            all_applicants_with_phone_no: {
                label: "Updated Applicants Details",
                check: !all_applicants_with_phone_no
            },
            is_pskit_attached: {
                label: "Is PS-Kit Attached",
                check: this.props.is_pskit_attached
            },
            is_processing_fee_added: {
                label: "Processing Fee Added",
                check: caseDetails.prepaid_processing_fee ? this.props.is_processing_fee_paid : true
            },
            is_seller_key_details_available: {
                label: "Seller Details",
                check: caseDetails.is_seller_key_details_available
            },
            is_scheme_added: {
                label: "Seller Scheme Added",
                check: caseDetails.is_scheme_added && caseDetails.is_scheme_dwd_sp_added
            },
            is_fee_available: {
                label: "Fee Program Added",
                check: caseDetails.is_fee_available
            },
            cibil_score: {
                label: "Associate CIBIL",
                check: !Number.isNaN(companyDetails.doesAllApplicantsHaveCibil)
            },
            is_withhold_account_added: {
                label: "Withhold Account for Seller Added",
                check: this.props.is_withhold_account_added
            },
            is_disbursal_account_added: {
                label: "Disbursal Account for Seller Added",
                check: this.props.is_disbursal_account_added
            }
        });

        if (
            evaluator.reduce(
                (agg, curr) => agg && curr.check,
                true
            )
        ) {
            this.moveCase(
                evaluator,
                true
            );
            return true;
        }
        this.moveCase(evaluator, false);

    }

    disableLosToLms = () => {
        if (this.props.isCreatedOnLMS || (
            Number(this.props.stageId) < 10 ||
            [18, 19].includes(Number(this.props.stageId))
        )) {
            return true;
        }
        return false;
    }

    toggleUTRForm = () => {
        this.setState({
            showUtrModal: !this.state.showUtrModal
        });
    }

    addUtr = (values) => {
        message.loading("Adding UTR Details...", 0);
        FacilityAccountService.addUTR({ case_id: this.props.caseId, ...values }).then(() => {
            message.destroy();
            message.success("UTR Details Added");
            this.props.fetchCaseDetail(this.props.caseId);
        }).catch(() => {
            message.destroy();
            message.error("Failed to load Details");

        }).finally(() => {
            this.toggleUTRForm();
        });
    }

    getExtraConditions = () => {
        if (this.props.caseDetails && !this.props.isSanctionCondition && this.props.bankId == "MF") {
            return (
                <Button type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={this.openSanctionModal}>{"Add Sanction Condition"}</Button>
            );
        } else if (this.props.caseDetails && this.props.isSanctionCondition && this.props.sanctionConditionStatus == 2) {
            return (
                <React.Fragment>
                    <Tag color={"blue"} className={"mr-5"}>{"Active"}</Tag>
                    {this.props.can_terminate_sanction_condition ? <Button type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={this.openSanctionTerminationModal}>{"Terminate Sanction Condition"}</Button> : null}
                </React.Fragment>
            );
        } else if (this.props.caseDetails && this.props.isSanctionCondition && this.props.sanctionConditionStatus == 4) {
            return (
                <Tag color={"red"}>{"Terminated"}</Tag>
            );
        }
        return null;
    }
    updatePF = (pfamount) => {
        try {
            pfamount && CaseService.updateProcessingFeeAmount(this.props.caseId, +pfamount)
                .then(res => {
                    return (res && res.status === 200 ? (this.setState({ processing_fee_amount: pfamount }), message.success("PF has been updated, please RE-TRIGGER the agreement", 5)) : message.error("Something went wrong"));
                })
                .catch((res) => {
                    message.error(res.non_field_errors && res?.non_field_errors.length && res?.non_field_errors[0] || res[Object.keys(res)] && res[Object.keys(res)][0] || "Something went wrong");
                });
        }
        catch (e) {
            message.error("Failed to execute. Please try after sometime");
        }
    }

    onChangeTenorInstance = (e) => {
        this.setState({ showTenorErr: false, errMsg: null });
        if (e.target.value < 1) {
            this.setState({ showTenorErr: true, errMsg: "Please Enter Correct Data" });
        } else {
            this.setState({
                emiInstanceToFillFields: {
                    ...this.state.emiInstanceToFillFields,
                    [e.target.name]: e.target.value,
                    "principal": this.state.emiInstancefields?.sanction_limit
                }
            });
        }
    }

    resetEmiSchedule = () => {
        this.setState({
            resetScheduleLoading : true
        })
        FacilityAccountService.resetEmiSchedule(this.props.caseId)
        .then((resp) => {
            this.props.fetchCaseDetail(this.props.caseId);
            this.setState({
                resetScheduleLoading : false
            });
            message.success("Schedule Successfully Updated");
        })
        .catch((err) => {
            this.setState({
                resetScheduleLoading : false
            })
            message.error("Something Went Wrong!")
        });
    }

    generateScheduleFn = () => {
        this.state.emiInstanceToFillFields["tenure"] && this.state.from_date ? FacilityAccountService.getGenerateScehduleBNPL(
            this.props.caseId,  
             this.state.emiInstanceToFillFields,
              this.state.from_date?.format("YYYY-MM-DD"),
              this.state.emiType,
              this.state.add_fees_to_first_tranche,
              this.state.first_instalment_deducted_from_disbursal,
              this.state.moratoriumDays
               ).then(({ data }) => {
            return (
                data.status == 200 ? this.setTableData(data.data) : message.error(data.message)
            );
        }).catch((err) => {
            return (
                message.error(err.message && err.message?.non_field_errors ? err.message?.non_field_errors?.length && err.message?.non_field_errors[0] || err[Object.keys(err)].length && err[Object.keys(err)][0] || "Please enter correct data" :"Something Went Wrong"),
                this.setState({ generateScehduleData: [] })
            );
        }) : message.error("Please fill Loan Amount/Tenure/Tentative Disbursal Date");
    }
    setTableData = (data) => {
        const dataStr = [];
        data.map((item) => {
            let orgData = {
                "instalment_nbr": item.instalment_nbr,
                "emi_amount": item.aggregate_emi_amount || item.emi_amount,
                "principal_amount": item.aggregate_principal_amount || item.principal_amount,
                "interest_amount": item.aggregate_interest_amount || item.interest_amount,
                "principal_receivable": item.aggregate_principal_receivable || item.principal_receivable,
                "interest_paid_till_date": item.aggregate_interest_paid_till_date || item.interest_paid_till_date,
                "tentative_due_date": item.tentative_due_date,
                "upfront_interest_amount": item.upfront_interest_amount
            };
            dataStr.push(orgData);
        });
        this.setState({ generateScehduleData: dataStr });
    }
    submitEmiInstance = () => {
        return (
            FacilityAccountService.postEmiInstance(
                this.props.caseId,
                {
                    ...this.state.emiInstanceToFillFields, tentative_disbursal_date: this.state.from_date?.format("YYYY-MM-DD"),
                    'moratorium_days': this.state.moratoriumDays,
                    'emi_type': this.state.emiType,
                    'add_fees_to_first_tranche': this.state.add_fees_to_first_tranche,
                    'is_first_instalment_deducted_from_disbursal': this.state.first_instalment_deducted_from_disbursal,
                }
                ).then(({ data }) => {
                this.setBnplLoanData();
                return (
                    data && data.status == 200 ? message.success(data.message) : message.error(data.message)
                );
            }));
    }
    handleDateInput = (type, _) => {
        this.setState({
            [type]: _
        });
    };


    saveSchedule = () => {
        this.state.save_data["tenure"] && this.state.save_data['from_date'] ? FacilityAccountService.saveScehduleBNPL(
            this.props.caseId,  
            this.state.save_data,
            !this.state.isBnplListDataPresent ? this.state.emiInstancefields?.sanction_limit : this.state.emiInstanceToFillFields.principal 
               ).then((response) => {
                message.success("Details Saved Successfully!")
                this.props.fetchCaseDetail(this.props.caseId);
            
        }).catch((err) => {
            return (
                message.error(err.message && err.message?.non_field_errors ? err.message?.non_field_errors?.length && err.message?.non_field_errors[0] || err[Object.keys(err)].length && err[Object.keys(err)][0] || "Please enter correct data" :"Something Went Wrong"),
                this.setState({ generateScehduleData: [] })
            );
        }) : message.error("Please fill Loan Amount/Tenure/Tentative Disbursal Date");
    
    }

    
    handlePfChargesModal = () => {
        const businessProductType = Number(this.props.caseDetails.get("business_product_type"));
        let applicableFeeProductType = null;
        if ([
            BUSINESS_PRODUCT_TYPE_UPDATED.get("INVOICE_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("PURCHASE_INVOICE_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("SALES_INVOICE_FINANCE"),
        ].includes(businessProductType)) {
            applicableFeeProductType = FEE_PRODUCT_TYPE.SCF;
        } else if ([
            BUSINESS_PRODUCT_TYPE_UPDATED.get("WORKING_CAPITAL_DEMAND_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("SHORT_TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("CONSUMER_FINANCE"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("LAP"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("PERSONAL_TERM_LOAN"),
            BUSINESS_PRODUCT_TYPE_UPDATED.get("RENOVATION_TERM_LOAN"),
        ].includes(businessProductType)) {
            applicableFeeProductType = FEE_PRODUCT_TYPE.TERM_LOAN;
        } else if (businessProductType === BUSINESS_PRODUCT_TYPE_UPDATED.get("VENDOR_FINANCE")) {
            applicableFeeProductType = FEE_PRODUCT_TYPE.VENDOR_FINANCE;
        } else if (businessProductType === BUSINESS_PRODUCT_TYPE_UPDATED.get("CEP")) {
            applicableFeeProductType = FEE_PRODUCT_TYPE.FACTORING;
        }
        this.props.fetchFee(
            this.props.caseDetails.getIn(['supply_chains', 0 ,'seller' ,  'id']),
            applicableFeeProductType
        );

        this.setState({
            pfChargeModalVisible : !this.state.pfChargeModalVisible
        })
    }
    handleBounceChargesModal = () => {
        this.props.fetchBounceCharges(this.props.caseDetails.getIn(['supply_chains', 0 ,'seller' ,  'id']));
        this.setState({
            bounceChargeModalVisible : !this.state.bounceChargeModalVisible
        })
    }
    handlePrePaymentChargesModal = () => {
        this.props.fetchPrePaymentCharges(this.props.caseDetails.getIn(['supply_chains', 0 ,'seller' ,  'id']));
        this.setState({
            prePaymentChargeModalVisible: !this.state.prePaymentChargeModalVisible
        })
    }

    changeFee = (type , val) => {
        const sellerId = this.props.caseDetails.getIn(['supply_chains', 0 ,'seller' ,  'id']);
        this.setState(prevState => ({
            changeFeeLoading: { ...prevState.changeFeeLoading, [type]: true }
        }));
        const stopLoading = () => this.setState(prevState => ({
            changeFeeLoading: { ...prevState.changeFeeLoading, [type]: false }
        }));
        const onError = () => {
            stopLoading();
            message.error("Something went wrong. Please try again!");
        };
        if (type == "fee"){
            CompanyLosServices.editCaseFee(sellerId, this.props.caseId , val)
            .then((resp) => {
                stopLoading();
                this.setState({
                    pfChargeModalVisible : false
                })
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch(onError)
        }else if(type == "bounce_charge"){
            CompanyLosServices.editBounceCharges(sellerId, this.props.caseId, val).then((resp) => {
                stopLoading();
                this.setState({
                    bounceChargeModalVisible : false
                })
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch(onError)
        }else if(type == "pre_payment_charge"){
            CompanyLosServices.editPrePaymentCharge(sellerId, this.props.caseId, val).then((resp) => {
                stopLoading();
                this.props.fetchCaseDetail(this.props.caseId);
                this.setState({
                    prePaymentChargeModalVisible: false
                })
            })
            .catch(onError)
        }
    }

    onSaveFields = (field, value) => {
        this.setState(prevState => ({
            save_data: {  
              ...prevState.save_data, 
              [field]: value
            }
          }));
    }

    render() {
        const isTermLoanCreatedOnLms = this.props.caseDetail.get('is_term_loan_created_on_lms');
        const isCreatedOnLms = this.props.caseDetail.get('is_created_on_lms');
        // const isGenerateSchedule = !isTermLoanCreatedOnLms && isCreatedOnLms
        const isGenerateSchedule= isCreatedOnLms ? isCreatedOnLms : (!isTermLoanCreatedOnLms && isCreatedOnLms) ;
        const recreditViewOnlyPermission = this.props.recreditViewOnlyPermission;
        const showSkipPodToggle = SKIP_POD_STAGE_IDS.includes(this.props.stageId);
        const isSkipPodToggleDisabled =
            SKIP_POD_READONLY_STAGE_IDS.includes(this.props.stageId) ||
            recreditViewOnlyPermission ||
            !!this.state.skipPod.modal ||
            this.state.skipPod.loading;
        const disableUpdate = (this.props.caseDetail.getIn(['current_case_task' , 0, 'this_stage'] , 0) != 11 && this.props.caseDetail.getIn(['current_case_task' , 0, 'this_stage'] , 0) != 7) || this.state.isBnplListDataPresent;
        const disableSave = (!this.props.caseDetails.get("default_foreclosure_charges") || !this.props.caseDetails.get("default_bounce_charges") || this.props.caseDetails.get("default_processing_fee") == null)
        const pricingSummary = this.getPricingSummary();
        return (
            <React.Fragment>
               
                <Modal
                    visible={this.state.showUtrModal}
                    footer={null}
                    onCancel={this.toggleUTRForm}
                    closable={true}
                    destroyOnClose={true}
                >
                    <UTRForm
                        processing_fee_amount={this.state.processing_fee_amount}
                        update={this.addUtr}
                    />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    closable={true}
                    visible={this.state.toggleSanctionModal}
                    onCancel={this.closeSanctionModal.bind(null, false)}
                    footer={null}
                >

                    <div className={"mt-10 w-100 d-flex flex-column"}>
                        <span style={{
                            fontWeight: 600
                        }}>{"Select Conditions"}</span>
                        <Checkbox.Group value={[this.state.selectedCondition]} onChange={this.onChangeCondition}>
                            {this.state.sanctionConditions.map((_, k) => {
                                let row = _;
                                // eslint-disable-next-line no-unused-vars
                                let myKeys = [];
                                const variableRegex = /(\{{.*?\}})/g;
                                myKeys = row.match(variableRegex);
                                let values = row.split(" ").map(__ => {
                                    if (myKeys.includes(__)) {
                                        return this.getOption(__, k);
                                    } else {
                                        return __;
                                    }
                                });
                                return (<Row key={k}>
                                    <Col span={2}>
                                        <Checkbox style={radioStyle} key={k} value={k}>
                                        </Checkbox>
                                    </Col>
                                    <Col span={22}>
                                        <p style={{
                                            lineHeight: "30px"
                                        }}>
                                            {values.map(__ => (
                                                // eslint-disable-next-line react/jsx-key
                                                <React.Fragment>{__} {" "}</React.Fragment>
                                            ))}
                                        </p>
                                    </Col>
                                </Row>);
                            }
                            )}
                        </Checkbox.Group>
                    </div>
                    <div className={"mt-10 w-100 d-flex flex-row justify-content-space-between"}>
                        <div>{""}</div>
                        <div>
                            <Button className={"mr-5"} type={"default"} size={"small"} onClick={this.closeSanctionModal.bind(null, false)}>
                                Cancel
                            </Button>
                            {!this.props.recreditViewOnlyPermission && <Button type={"primary"} disabled={this.isSanctionDisabled()} size={"small"} onClick={this.closeSanctionModal.bind(null, true)}>
                                Update
                            </Button>}
                        </div>
                    </div>
                </Modal>
                <Modal
                    title={"Add Termination Remarks"}
                    destroyOnClose={true}
                    onOk={this.terminateSanctionCondition}
                    onCancel={this.closeSanctionTerminationModal}
                    visible={this.state.showSanctionTerminationModal}
                >
                    <div className={"p-5"}>
                        <Input.TextArea
                            value={this.state.sanctionTerminationRemarks}
                            onChange={this.onChangeTerminationRemarks}
                            autoSize={{
                                minRows: 2,
                                maxRows: 4
                            }}
                        />
                    </div>
                </Modal>
                <Modal
                    title={"Update Processing Fee Amount"}
                    visible={this.state.pfAmountModal.visible}
                    onCancel={this.closePfAmountModal}
                    onOk={this.submitPfAmountModal}
                    confirmLoading={this.state.pfAmountModal.submitting}
                    okText={"Submit"}
                    destroyOnClose={true}
                >
                    <div className={"mb-10"}>
                        <div className={"mb-5"}>{"Fee Program"}</div>
                        <Select
                            showSearch
                            className={"w-100"}
                            placeholder={"Select fee program"}
                            loading={this.state.pfAmountModal.loading}
                            value={this.state.pfAmountModal.form.feeMasterId}
                            onChange={(value) => this.onPfAmountModalFormChange("feeMasterId", value)}
                            optionFilterProp={"children"}
                        >
                            {this.state.pfAmountModal.feePrograms.map((row) => {
                                const feeMasterId = row?.fee_master?.id || row?.fee_master;
                                const feeMasterName =
                                    row?.fee_master?.name ||
                                    row?.fee_master_name ||
                                    row?.name ||
                                    `Fee Program ${feeMasterId || row?.id}`;
                                const configurations = row?.fee_master?.configuration || [];
                                // Disable if ANY slab is ended (active_to <= today)
                                const isExpired = configurations.some((c) =>
                                    !!c?.active_to && moment(c.active_to).isSameOrBefore(moment(), "day")
                                );
                                if (!feeMasterId) {
                                    return null;
                                }
                                return (
                                    <Select.Option key={feeMasterId} value={feeMasterId} disabled={isExpired}>
                                        {feeMasterName}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div>
                        <div className={"mb-5"}>{"Remarks"}</div>
                        <Input.TextArea
                            placeholder={"Enter remarks"}
                            value={this.state.pfAmountModal.form.remarks}
                            onChange={(e) => this.onPfAmountModalFormChange("remarks", e.target.value)}
                            autoSize={{ minRows: 3, maxRows: 5 }}
                        />
                    </div>
                </Modal>
                <Modal
                    title={this.state.skipPod.modal?.pending ? "Skip POD Stage" : "Revert Skip POD Stage"}
                    visible={!!this.state.skipPod.modal}
                    onCancel={this.closeSkipPodModal}
                    onOk={this.submitSkipPodModal}
                    confirmLoading={this.state.skipPod.modal?.submitting}
                    okText={"Submit"}
                >
                    <div className={"mb-5"}>{"Remarks"}</div>
                    <Input.TextArea
                        placeholder={"Enter remarks"}
                        value={this.state.skipPodRemarks}
                        onChange={(e) => this.setState({ skipPodRemarks: e.target.value })}
                        autoSize={{ minRows: 3, maxRows: 5 }}
                    />
                </Modal>
                <Row className={"p-5"}>
                    <Col span={24} className={"p-10 d-flex justify-content-space-between align-items-center"}>
                        <div className={"d-flex align-items-center"}>
                            {/* Bank Ps-Kit 14 , Post sanction document 10, Progcap PS-kit 11 */}
                            {!this.props.caseDetails?.toJS()?.is_bnpl_case &&  <>
                            <span className={"mr-5"}>
                                {"Processing Fee Amount: "}
                            </span>
                            <span>
                                <Card size={"small"} style={{ border: "none", boxShadow: "none" }}>
                                    <Paragraph style={{ marginBottom: "0", fontSize: "15px", lineHeight: "1", color: "rgb(86 84 84 / 85%)" }}
                                        className={"d-flex justify-content-space-between"}
                                        level={4}
                                    >
                                        {this.state.processing_fee_amount}
                                        {
                                            ([1, 3].includes(this.props.caseDetails.case_status)) && this.props?.user.stage_admin.includes(11) && !recreditViewOnlyPermission
                                                ? <Icon type={"edit"} style={{ marginLeft: "8px" }} onClick={this.openPfAmountModal} />
                                                : null
                                        }
                                    </Paragraph>
                                </Card>
                            </span></>}
                            {this.props.caseDetails && this.props.caseDetails.prepaid_processing_fee ? (this.props.is_processing_fee_paid ?
                                (
                                    <Tag className={"ml-05"} color={"blue"}>{"Paid Already"}</Tag>
                                ) :
                                (<Button size={"small"} className={"ml-05"} onClick={this.toggleUTRForm} disabled={this.props.recreditViewOnlyPermission}>
                                    {"Add UTR Details"}
                                </Button>)) : null}
                            {showSkipPodToggle && (
                                <span className={"ml-10 d-flex align-items-center"}>
                                    <span className={"mr-5"}>{"Skip POD Stage:"}</span>
                                    <Switch
                                        checked={this.state.skipPod.value}
                                        loading={this.state.skipPod.loading}
                                        onChange={this.onSkipPodToggle}
                                        disabled={isSkipPodToggleDisabled}
                                    />
                                </span>
                            )}
                        </div>
                        <div>
                            <span className={"mr-5"}>
                                {"Stamp Charges: "}
                            </span>
                            <span>
                                {`₹${this.props.caseDetails &&
                                    this.props.caseDetails.documentation_charges &&
                                    formatCurrency(this.props.caseDetails.documentation_charges)
                                    }`}
                            </span>
                        </div>
                        {!recreditViewOnlyPermission && ![7, 8].includes(this.props.stageId) && <Button size={"small"} onClick={this.moveCaseCheckList} disabled={this.disableLosToLms()} type={this.props.isCreatedOnLMS ? "secondary" : "primary"} >
                            {this.props.isCreatedOnLMS ? "Moved to LMS" : "LOS to LMS"}
                        </Button>}
                    </Col>
                    {this.state.latestPricing ? (
                        <Col span={24} className={"p-10"}>
                            <Card
                                title={"Pricing"}
                                extra={
                                    pricingSummary.approvalStatusUi ? (
                                        <span
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 6,
                                                color: pricingSummary.approvalStatusUi.color,
                                                fontWeight: 600,
                                                fontSize: 14,
                                            }}
                                        >
                                            <Icon
                                                type={pricingSummary.approvalStatusUi.icon}
                                                style={{ fontSize: 15 }}
                                            />
                                            {pricingSummary.approvalStatusUi.label}
                                        </span>
                                    ) : null
                                }
                                bodyStyle={{ padding: 0 }}
                            >
                                <div style={{ padding: "12px 16px" }}>
                                    <Row type="flex" justify="space-between" align="middle">
                                        {[
                                            { label: "ROI", value: pricingSummary.roiText },
                                            { label: "PF", value: pricingSummary.pfText },
                                            { label: "Tenor", value: pricingSummary.tenorText },
                                            { label: "EMI", value: pricingSummary.emiText },
                                        ].map((item, idx, arr) => (
                                            <Col
                                                key={item.label}
                                                span={6}
                                                style={{
                                                    textAlign: "center",
                                                    borderRight: idx !== arr.length - 1 ? "1px solid #eee" : "none"
                                                }}
                                            >
                                                <div style={{ color: "#6b7280", fontSize: 12 }}>{item.label}</div>
                                                <div style={{ fontWeight: 700, color: "#d28b2d", fontSize: 16 }}>
                                                    {item.value}
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                    <div style={{ marginTop: 10, color: "#9ca3af", fontSize: 12 }}>
                                        {pricingSummary.updatedAt
                                            ? moment(pricingSummary.updatedAt).format("MMM DD, YYYY - h:mm A")
                                            : ""}
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    ) : null}
                    {
                        this.props.caseDetails?.toJS()?.is_bnpl_case && <Col span={24} className={"p-10"}>
                            <Card title={<h3 className="m-0">Term Loan Product Details</h3>}>
                                <Row>
                                    <div className={"w-100 d-flex justify-content-space-between"}>
                                        <h3 style={{
                                            fontWeight: "600"
                                        }} className={"w-60"}>
                                            {"Calculate EMI For Instance"}
                                        </h3>
                                    </div>
                                    
                                    <Row type="flex" justify="space-between" align="middle">
                                        <Col span={4} >
                                            <span className="text-font-12">Loan Amount (Principal) <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={"Minimum amount:" + this.state.emiInstancefields?.loan_amount_min + " " + "Maximum amount:" + this.state.emiInstancefields?.loan_amount_max + ""} /></span>
                                            {
                                                !this.state.isBnplListDataPresent ? <Input value={this.state.emiInstancefields?.sanction_limit} disabled={true} /> : <Input value={this.state.emiInstancefields["principal"]} disabled={true} />
                                            }
                                            {this.state.showErr && <span className={"error-text"} style={{ fontSize: "12px" }}>{this.state.errMsg}</span>}
                                        </Col>
                                        {isGenerateSchedule ? <Col span={4} >
                                            <span className="text-font-12">Tenure</span>
                                            {
                                                !this.state.isBnplListDataPresent ? <Input name="tenure" disabled={recreditViewOnlyPermission} onChange={this.onChangeTenorInstance} /> : <Input value={this.state.emiInstancefields["tenure"] || this.state.emiInstancefields["tenor"]} disabled={true} />
                                            }
                                            {this.state.showTenorErr && <span className={"error-text"} style={{ fontSize: "12px" }}>{this.state.errMsg}</span>}
                                        </Col> : <Col span={4} >
                                            <span className="text-font-12">Tenure</span>
                                            <Input name="tenure" onChange={(e) => this.onSaveFields('tenure' , e.target.value)} value={this.state.save_data['tenure']}/>
                                        </Col>}
                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">{this.state.emiInstancefields["instalment_date_type"] === "EMI Date" ? "EMI Date" : "Disbursal Date"}</span>
                                            <Input 
                                                disabled={true} 
                                                value={this.state.emiInstancefields ? this.state.emiInstancefields["aggregate_disbursal_date"] || this.state.emiInstancefields["emi_date"] : ""} 
                                            />
                                        </Col>
                                        {isGenerateSchedule ? <Col span={4}>
                                            <span className="text-font-12">{"Tentative Disbursal Date"}</span>
                                            {this.state.emiInstancefields &&( this.state.emiInstancefields["aggregate_tentative_disbursal_date"] || this.state.emiInstancefields["tentative_disbursal_date"]) ?
                                                <Input
                                                    disabled={true}
                                                    value={
                                                        this.state.emiInstancefields ? this.state.emiInstancefields["aggregate_tentative_disbursal_date"] || this.state.emiInstancefields["tentative_disbursal_date"] : ""}
                                                />
                                                : <DatePicker
                                                    size={"default"}
                                                    onChange={this.handleDateInput.bind(
                                                        null,
                                                        START_DATE
                                                    )}
                                                    format={"YYYY-MM-DD"}
                                                    disabledDate={(current) => {
                                                        return moment().add(-1, "days") >= current;
                                                    }}
                                                    disabled={!(!recreditViewOnlyPermission && !this.state.isBnplListDataPresent)}
                                                    value={this.state.from_date}
                                                    required={true}
                                                />}
                                        </Col> : 
                                        <Col span={4}>
                                            <span className="text-font-12">{"Tentative Disbursal Date"}</span>
                                            <DatePicker
                                                size={"default"}
                                                onChange={(e) => this.onSaveFields('from_date', e)}
                                                format={"YYYY-MM-DD"}
                                                disabledDate={(current) => {
                                                    return moment().add(-1, "days") >= current;
                                                }}
                                                value={this.state.save_data['from_date']}
                                                required={true}
                                            />
                                    </Col>
                                        }
                                        {isGenerateSchedule ? <Col span={4}>
                                            <span className="text-font-12">{"Moratorium Day"}</span>
                                            <InputNumber 
                                                className="ant-number-input-width" 
                                                onChange={(value) => this.setState({
                                                    moratoriumDays : value
                                                })}  
                                                value={this.state.isBnplListDataPresent ? this.state.emiInstancefields["max_moratorium_days"] || this.state.emiInstancefields['max_moratorium_period'] || 0  :  this.state.emiInstancefields['max_moratorium_period']}
                                                // disabled={this.state.emiInstancefields ? 
                                                //     (this.state.emiInstancefields["max_moratorium_days"] == 0) || this.state.isBnplListDataPresent  
                                                // : true}
                                                disabled={true}
                                                min={0} 
                                                max={this.state.isBnplListDataPresent ? this.state.emiInstancefields["max_moratorium_days"] || 0 : this.state.emiInstancefields['max_moratorium_period']}
                                            />
                                            {(this.state.emiInstancefields && !this.state.isBnplListDataPresent) && <span>Range: {0 + '-' + (this.state.emiInstancefields["max_moratorium_period"] || '0')} </span>}
                                        </Col>:
                                        <Col span={4}>
                                            <span className="text-font-12">{"Moratorium Day"}</span>
                                            <InputNumber 
                                                disabled={true}
                                                className="ant-number-input-width" 
                                                onChange={(value) => this.onSaveFields('moratorium_days' , value)}  
                                                value={this.state.save_data['moratorium_days']}
                                                min={0} 
                                                max={this.state.isBnplListDataPresent ? this.state.emiInstancefields["max_moratorium_days"] || 0 : this.state.emiInstancefields['max_moratorium_period']}
                                            />
                                            {(this.state.emiInstancefields && !this.state.isBnplListDataPresent) && <span>Range: {0 + '-' + (this.state.emiInstancefields["max_moratorium_period"] || '0')} </span>}
                                        </Col>}
                                    </Row>
                                    <Row type="flex" justify="space-between" align="middle">
                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">Rate of Interest (%)</span>
                                            <Input disabled={true} value={this.state.emiInstancefields ? this.state.emiInstancefields['min_normal_roi'] || this.state.emiInstancefields['roi'] : ""} />
                                        </Col>


                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">EMI Frequency</span>
                                            <Input disabled={true}
                                                value={this.state.emiInstancefields ?
                                                    Number.isInteger(this.state.emiInstancefields['instalment_frequency'])
                                                        ? InstalmentFrequencyType[this.state.emiInstancefields['instalment_frequency']]
                                                        : this.state.emiInstancefields['instalment_frequency']
                                                    : ""} />
                                        </Col>
                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">EMI Date Type</span>
                                            <Input disabled={true}
                                                value={this.state.emiInstancefields ?
                                                    Number.isInteger(this.state.emiInstancefields['instalment_date_type'])
                                                        ? InstalmentDateType[this.state.emiInstancefields['instalment_date_type']]
                                                        : this.state.emiInstancefields['instalment_date_type']
                                                    : ""}
                                            />
                                        </Col>
                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">Interest Type</span>
                                            <Input disabled={true}
                                                value={this.state.emiInstancefields ?
                                                    Number.isInteger(this.state.emiInstancefields['interest_type'])
                                                        ? InterestType[this.state.emiInstancefields['interest_type']]
                                                        : this.state.emiInstancefields['interest_type']
                                                    : ""}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <span className="text-font-12">{"Moratorium Interest Charges"}</span>
                                            <Input
                                                disabled={true}
                                                value={this.state.emiInstancefields ? this.state.emiInstancefields["is_moratorium_interest_charged"] ? "Yes" : "No" : ""} />
                                        </Col>
                                    </Row>

                                    <Row type="flex" justify="space-between" align="middle">
                                        {isGenerateSchedule ? <Col span={4}>
                                            <span className="text-font-12 d-block">{"EMI Type"}</span>
                                            <Radio.Group 
                                                disabled={this.state.isBnplListDataPresent}
                                                value={this.state.isBnplListDataPresent ? String(this.state.emiInstancefields["emi_type"]) : this.state.emiType  }
                                                onChange={(e) => this.setState({
                                                emiType : e.target.value
                                            })}>
                                                <Radio.Button value="1">ARREARS</Radio.Button>
                                                <Radio.Button value="2">ADVANCE</Radio.Button>
                                            </Radio.Group>
                                        </Col>:
                                        <Col span={4}>
                                            <span className="text-font-12 d-block">{"EMI Type"}</span>
                                            <Radio.Group 
                                                disabled={this.state.isBnplListDataPresent}
                                                value={this.state.save_data['emiType']}
                                                onChange={(e) => this.onSaveFields('emiType' , e.target.value)}>
                                                <Radio.Button value="1">ARREARS</Radio.Button>
                                                <Radio.Button value="2">ADVANCE</Radio.Button>
                                            </Radio.Group>
                                        </Col> }
                                        <Col span={4}>
                                            {/* <span className="text-font-12">{"Add PF & DC to First Tranche "}</span>
                                           
                                            <Radio.Group
                                                disabled={this.state.isBnplListDataPresent}
                                                value={this.state.isBnplListDataPresent ? this.state.emiInstancefields["add_fees_to_first_tranche"] : this.state.add_fees_to_first_tranche}
                                                onChange={(e) => this.setState({
                                                    add_fees_to_first_tranche: e.target.value
                                                })}>
                                                <Radio.Button value={true}>Yes</Radio.Button>
                                                <Radio.Button value={false}>No</Radio.Button>
                                            </Radio.Group> */}
                                            <span className="text-font-12">Margin</span>
                                            <Input
                                                disabled={true}
                                                value={this.state.emiInstancefields ? this.state.emiInstancefields["withhold_perc"] : ""} />

                                        </Col>
                                        <Col span={4}>
                                            <span className="text-font-12">{"Moratorium Period Interest Amount"}</span>
                                            <Input
                                                disabled
                                                value={this.state.emiInstancefields ?
                                                    this.state.emiInstancefields["sum_moratorium_period_interest_amount "] ?
                                                        this.state.emiInstancefields["sum_moratorium_period_interest_amount "] :
                                                        this.state.emiInstancefields["sum_tentative_moratorium_period_interest_amount"] :
                                                    "0"} />
                                        </Col>

                                        <Col span={4}>
                                            <span className="text-font-12">{"Moratorium Period End Date "}</span>
                                            <Input
                                                disabled
                                                value={this.state.emiInstancefields ?
                                                    this.state.emiInstancefields["moratorium_period_end_date"] ?
                                                        this.state.emiInstancefields["moratorium_period_end_date"] :
                                                        this.state.emiInstancefields["tentative_moratorium_period_end_date"] :
                                                    "0"} />
                                        </Col>
                                        {isGenerateSchedule ?  <Col span={4}>
                                            <span className="text-font-12">{"Deduct First Instalment At Disbursal"}</span>
                                            <Radio.Group
                                                disabled={this.state.isBnplListDataPresent}
                                                value={this.state.isBnplListDataPresent ? this.state.emiInstancefields["is_first_instalment_deducted_from_disbursal"] :  this.state.first_instalment_deducted_from_disbursal }
                                                onChange={(e) => this.setState({
                                                    first_instalment_deducted_from_disbursal: e.target.value
                                                })}
                                            >
                                                <Radio.Button value={true}>Yes</Radio.Button>
                                                <Radio.Button value={false}>No</Radio.Button>
                                            </Radio.Group>
                                        </Col>: 
                                        <Col span={4}>
                                            <span className="text-font-12">{"Deduct First Instalment At Disbursal"}</span>
                                            <Radio.Group
                                                value={this.state.save_data["is_first_instalment_deducted_from_disbursal"]}
                                                onChange={(e) => this.onSaveFields('is_first_instalment_deducted_from_disbursal' , e.target.value)}
                                            >
                                                <Radio.Button value={true}>Yes</Radio.Button>
                                                <Radio.Button value={false}>No</Radio.Button>
                                            </Radio.Group>
                                        </Col>
                                        }
                                    </Row>

                                    <Row type="flex" className="margin-10-top-bottom" justify="space-between" align="middle">
                                    <Col span={4}>
                                            <span className="text-font-12">{"Buyer Subvention Days"}</span>
                                            <InputNumber 
                                                className="ant-number-input-width" 
                                                onChange={(value) => this.setState({
                                                    moratoriumDays : value
                                                })}  
                                                value={this.state.emiInstancefields["buyer_subvention_days"]}
                                                disabled={true}
                                                min={0} 
                                                max={this.state.emiInstancefields["buyer_subvention_days"] || 0}
                                            />
                                        </Col>
                                        <Col span={4} className="margin-10-top-bottom">
                                            <span className="text-font-12">Seller Subvention Days</span>
                                            <Input disabled={true}
                                                value={this.state.emiInstancefields ? this.state.emiInstancefields['seller_subvention_days'] : ""}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <span className="text-font-12">PF Charges</span>
                                            <div>
                                                <span className={disableUpdate ? "disabled" : ""}>{(this.props.caseDetails.get("default_processing_fee") != null ? this.props.caseDetails.get("default_processing_fee", '') : "") + " " +  this.props.caseDetails.getIn(["default_processing_charges", "description"], '') }
                                                <Icon type="edit" onClick={ disableUpdate? null : () => this.handlePfChargesModal()} /></span>
                                            </div>
                                        </Col>
                                        <Col span={4}>
                                            <span className="text-font-12">Bounce Charges</span>
                                            <div>
                                                <span className={disableUpdate ? "disabled" : ""}>{this.props.caseDetails.getIn(["default_bounce_charges", "configuration",  "charge_json",  "charges"])}
                                                <Icon type="edit" onClick={disableUpdate ? null : () => this.handleBounceChargesModal()} /></span>
                                            </div>
                                        </Col>
                                        <Col span={4}>
                                            <span className="text-font-12">Pre-payment Charges  </span>
                                            <div>
                                                <span className={disableUpdate ? "disabled" : ""}>{(this.props.caseDetails.getIn(["default_foreclosure_charges", "configuration"]) || new List())
                                                    .map(_ => (_ && _.get ? _.get("description") : _ && _.description))
                                                    .filter(Boolean)
                                                    .join(", ")}
                                                <Icon type="edit" onClick={disableUpdate  ? null : () => this.handlePrePaymentChargesModal()} /></span>
                                                
                                            </div>
                                        </Col>
                                    </Row>
                                    <CompanyFeeForm
                                        loading={this.state.changeFeeLoading.fee}
                                        onValuesSubmit={(val) => this.changeFee("fee" , val)}
                                        toggleModal={this.handlePfChargesModal}
                                        visible={this.state.pfChargeModalVisible}
                                        update
                                        useLegacyFeeProgramModal={true}
                                        hideLegacyLastToLimitUpdate={true}
                                        feeMaster={this.props.feeData}
                                    />
                                    <CompanyBounceChargeForm
                                        loading={this.state.changeFeeLoading.bounce_charge}
                                        onValuesSubmit={(val) =>this.changeFee("bounce_charge" , val) }
                                        toggleModal={this.handleBounceChargesModal}
                                        visible={this.state.bounceChargeModalVisible}
                                        bounceChargesMaster={this.props.bounceChargesList.get("data")}
                                        update
                                    />
                                    <CompanyPrePaymentChargeForm
                                        loading={this.state.changeFeeLoading.pre_payment_charge}
                                        onValuesSubmit={(val) =>  this.changeFee("pre_payment_charge", val)}
                                        toggleModal={this.handlePrePaymentChargesModal}
                                        visible={this.state.prePaymentChargeModalVisible}
                                        prePaymentChargesMaster={this.props.prePaymentChargesList.get("data")}
                                        update
                                    />
                                    {
                                        !this.state.isBnplListDataPresent ? 
                                        <div className="d-flex justify-content-left" style={{ margin: "2rem 0" }}>
                                            {![7, 8].includes(this.props.stageId) && <Button 
                                            disabled={!(!recreditViewOnlyPermission && !(this.state.showErr || this.state.showTenorErr))} 
                                            type="primary" 
                                            style={(this.state.showErr || this.state.showTenorErr) ? { backgroundColor: "#f7f7f7" } : { backgroundColor: "#1D7B8F", borderRadius: "8px" }} 
                                            onClick={this.generateScheduleFn}>
                                                Generate Schedule
                                            </Button>}
                                            {[7, 8].includes(this.props.stageId) && <Button 
                                                disabled={(!(!recreditViewOnlyPermission && !(this.state.showErr || this.state.showTenorErr))) || disableSave} 
                                                type="primary" 
                                                style={(this.state.showErr || this.state.showTenorErr || disableSave ) 
                                                        ? { backgroundColor: "#f7f7f7", marginLeft : 10 } : { backgroundColor: "#1D7B8F", borderRadius: "8px" ,marginLeft : 10}} 
                                                onClick={() => this.saveSchedule()}>
                                                    Save Schedule
                                                </Button>}
                                        </div> : <div style={{ margin: "2rem 0" }}>
                                            
                                            <ConfirmButton 
                                                disabled={this.props.caseDetail.getIn(['current_case_task' , 0, 'this_stage'] , 0) != 11}
                                                type={"primary"}
                                                label="Reset Schedule"
                                                onConfirm={() => this.resetEmiSchedule()}
                                                description={"Are you sure you want to Reset Schedule"} 
                                                loading={this.state.resetScheduleLoading}
                                            />
                                        </div>
                                    }

                                </Row>
                                <div
                                    itemLayout={"vertical"} className="d-flex justify-content-space-between"
                                >
                                    <div key={"sanction_remarks"} className="w-55 mt-20">

                                        {this.state.generateScehduleData.length > 0 && <div className="d-flex justify-content-space-between">
                                            <div className="emi-view-modal-headers">
                                                <table className="emi-view-table-border">
                                                    <thead className="header-fixed">
                                                        <tr>
                                                            {Object.keys(emiInstanceColumns).map((el, idx) => {
                                                                return (
                                                                    <th style={{ backgroundColor: "#F1EFEF"}} className="text-font-13 emi-view-row-headers" key={idx}>
                                                                        {emiInstanceColumns[el].title}
                                                                    </th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* <div className="table-scrollable"> */}
                                                            {this.state.generateScehduleData.map((el, idx) =>
                                                                <tr key={idx}>
                                                                    {Object.values(el).map((value, index) => <td key={index} className="emi-view-row-body">{emiInstanceColumns[Object.keys(el)[index]].type == 'amount' ? formatCurrency(value, false) :value}</td>)}
                                                                </tr>
                                                            )}
                                                        {/* </div> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>}
                                        {this.state.generateScehduleData.length > 0 && !this.state.isBnplListDataPresent && !recreditViewOnlyPermission && <div className="d-flex justify-content-center" style={{ margin: "2rem 0" }}>
                                            <Button type="primary" style={{ backgroundColor: "#1D7B8F", borderRadius: "8px" }} onClick={this.submitEmiInstance}>Submit</Button>
                                        </div>}
                                    </div>
                                    <div key={"schedule_of_charges"} className="w-40">
                                        <div className={"w-100 d-flex justify-content-space-between flex-column"}>
                                            {/* <h2 style={{
                                                fontWeight: "600", fontSize: "16px"
                                            }} className={""}>
                                                {"Schedule Of Charges"}
                                            </h2> */}
                                            <Descriptions title="Schedule Of Charges" layout="vertical" bordered>
                                            {Object.keys(scheduleCharges).map((el, idx) => {
                                                if(scheduleCharges[el].type == "label"){
                                                    return <Descriptions.Item label={scheduleCharges[el].title}
                                                    >{this.state.scheduleOfChargesData && this.state.scheduleOfChargesData[el]?.value || "--"}
                                                    </Descriptions.Item>
                                                }
                                                else if(scheduleCharges[el].type == "table"){
                                                    return <Descriptions.Item label={scheduleCharges[el].title}>
                                                    <table className="emi-view-table-border">
                                                        <thead className="header-fixed">
                                                            <tr>
                                                                <th>From Tenure</th>
                                                                <th>To Tenure</th>
                                                                <th>Charges</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.scheduleOfChargesData[el]?.value && this.state.scheduleOfChargesData[el]?.value.map(_ => <tr>
                                                                <td>{_.from_tenure}</td>
                                                                <td>{_.to_tenure}</td>
                                                                <td>{_.value}</td>
                                                            </tr>)}                                                            
                                                        </tbody>
                                                    </table>
                                                </Descriptions.Item>
                                                }
                                            })}                                                                                                
                                            </Descriptions>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    }
                    <Col span={24} className={"p-10"}>
                        <Card title={"Sanction Conditions And Remarks"} extra={this.getExtraConditions()}>
                            <AntList
                                itemLayout={"horizontal"}
                            >
                                <ListItem key={"sanction_remarks"}>
                                    <div className={"w-100 d-flex justify-content-space-between"}>
                                        <span style={{
                                            fontWeight: "600"
                                        }} className={"fb-30"}>
                                            {"Sanction Remarks"}
                                        </span>
                                        <div className={"d-flex justify-content-flex-emd"}>
                                            {this.props.caseDetails && this.props.caseDetails.sanction_remarks}
                                        </div>
                                    </div>
                                </ListItem>
                                <ListItem key={"sanction_condition"}>
                                    <div className={"w-100 d-flex justify-content-space-between"}>
                                        <span style={{
                                            fontWeight: "600"
                                        }} className={"fb-30"}>
                                            {"Sanction Condition"}
                                        </span>
                                        <div className={"d-flex justify-content-flex-end"}>
                                            {
                                                (this.props.caseDetails &&
                                                    this.props.caseDetails.sanction_condition &&
                                                    this.props.caseDetails.sanction_condition.title)
                                                ||
                                                "--"
                                            }
                                        </div>
                                    </div>
                                </ListItem>
                            </AntList>
                        </Card>
                    </Col>
                    <Col span={24} className={"p-10"}>
                        <AccountFacilityForm
                            submitForm={this.submitForm}
                            values={this.props.values}
                            supplyChains={this.props.supplyChains}
                            bankId={this.props.bankId}
                            processingFeeAmountFromCaseDetails={Number(this.props.processingFeeAmountFromCaseDetails)}
                            user={this.props.user}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

AccountFacilityTab.propTypes = {
    history: PropTypes.object,
    createFacilityAccount: PropTypes.func,
    companyId: PropTypes.number,
    associates: PropTypes.object,
    caseId: PropTypes.string,
    fetchFacilityAccount: PropTypes.func,
    values: PropTypes.object,
    fetchFacilityAccountSupplyChains: PropTypes.func,
    updateFacilityAccountSupplyChains: PropTypes.func,
    supplyChains: PropTypes.object,
    bankId: PropTypes.number,
    updateProcessingFee: PropTypes.func,
    processingFeeAmountFromCaseDetails: PropTypes.string,
    caseDetails: PropTypes.object,
    stagePermissions: PropTypes.object,
    updateCaseDetail: PropTypes.func,
    isSanctionCondition: PropTypes.bool,
    is_pskit_attached: PropTypes.bool,
    companyDetails: PropTypes.object,
    isCreatedOnLMS: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    stageId: PropTypes.bool,
    caseDetailsStatus: PropTypes.string,
    is_processing_fee_paid: PropTypes.string,
    fetchCaseDetail: PropTypes.func,
    fetchCaseNotes: PropTypes.func,
    sanctionConditionStatus: PropTypes.number,
    sanctionConditionStatusRemarks: PropTypes.string,
    can_terminate_sanction_condition: PropTypes.bool,
    is_withhold_account_added: PropTypes.bool,
    is_disbursal_account_added: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    user: PropTypes.object,
};

const mapStateToProps = (state, props) => ({
    associates: (state.companies.getIn([props.companyId, "data", "associates"]) || new Map({})).filter(_ => [1, 2].includes(Number(_.type))),
    values: state.facilityAccount.get("data"),
    stagePermissions: state.stagePermissions.get("data"),
    caseDetails: state.caseDetails.getIn([props.caseId, "data"]),
    supplyChains: state.facilityAccount.getIn(["supply_chains", props.caseId, "data"]),
    bankId: state.caseDetails.getIn([props.caseId, "data", "bank", "code"]),
    processingFeeAmountFromCaseDetails: state.caseDetails.getIn([props.caseId, "data", "processing_fee_amount"]),
    isSanctionCondition: !!(Object.keys(state.caseDetails.getIn([props.caseId, "data", "sanction_condition"]) || {}).length),
    companyDetails: state.companies.getIn([props.companyId, "data"]),
    sanctionConditionStatus: state.caseDetails.getIn([props.caseId, "data", "sanction_condition_status"]),
    sanctionConditionStatusRemarks: state.caseDetails.getIn([props.caseId, "data", "sanction_condition_status_remarks"]),
    is_pskit_attached: (state.documents.getIn([
        "company_documents",
        props.companyId,
        "data"
    ]) || new Map({})).map(_ => _.get("data")).toList().toArray().filter(_ => {
        return _ &&
            _.document &&
            _.document.id &&
            [18, 19, 20, 56].includes(Number(_.document.id));
    }),
    isCreatedOnLMS: state.caseDetails.getIn([props.caseId, "data", "is_created_on_lms"]),
    is_processing_fee_paid: state.caseDetails.getIn([props.caseId, "data", "is_processing_fee_paid"]),
    can_terminate_sanction_condition: state.caseDetails.getIn([props.caseId, "data", "can_terminate_sanction_condition"]),
    is_withhold_account_added: state.caseDetails.getIn([props.caseId, "data", "is_withhold_account_added"]),
    is_disbursal_account_added: state.caseDetails.getIn([props.caseId, "data", "is_disbursal_account_added"]),
    user: state.user.get("data"),
    prePaymentChargesList: state.companyLosProfiles.get('prePaymentCharges', Map()),
    bounceChargesList: state.companyLosProfiles.get('bounceCharges' , Map()),
    feeData: state.companyLosProfiles.getIn(["fee", props.caseDetail.getIn(['supply_chains', 0 ,'seller' ,  'id']), "data"], new List([])),

});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createFacilityAccount,
            fetchFacilityAccount,
            fetchFacilityAccountSupplyChains,
            updateFacilityAccountSupplyChains,
            updateProcessingFee,
            updateCaseDetail,
            fetchCaseDetail,
            fetchCaseNotes,
            fetchBounceCharges,
            fetchPrePaymentCharges,
            fetchFee
        
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AccountFacilityTab);